export default "__VITE_ASSET__CS5GYMA$__"